// extracted by mini-css-extract-plugin
module.exports = {"modal":"showModal_modal__iteqG","hasFooter":"showModal_hasFooter__2e7OE","modalBody":"showModal_modalBody__1C5ld","modalFooter":"showModal_modalFooter__2RXDf"};